import Head from 'next/head';

type Props = {
  readonly children: React.ReactNode;
};
export function XHead({ children }: Props) {
  return <Head>{children}</Head>;
}
